module.exports = __webpack_public_path__ + "static/media/cart-new.780bdc08.svg";